<template>
  <el-dialog
    :title="channel ? 'Add channel' : 'Choose a channel'"
    :visible="dialog"
    width="500px"
    top="3vh"
    :modal="true"
    :append-to-body="true"
    @close="setDialog(false)"
  >
    <div class="align-center">
      <div class="ml10 mr20">
        <div v-if="channel">
          <h1>
            {{ channel.title }}
          </h1>
        </div>
        <el-autocomplete
          class="input mb10"
          v-else
          v-model="channel_id"
          :fetch-suggestions="showSuggestions"
          :trigger-on-focus="false"
          :debounce="500"
          prefix-icon="el-icon-search"
          placeholder="Search channels"
          @select="handleSelect"
          :maxlength="100"
        >
          <div slot-scope="props" class="flex-start">
            {{ props.item.title }}
          </div>
        </el-autocomplete>
      </div>
      <span
        slot="footer"
        class="dialog-footer flex-space-evenly"
        v-if="channel"
      >
        <el-button
          type="primary"
          class="ml10 mb10"
          size="medium"
          :loading="loading"
          @click="insert(channel), ((visible = true), (channel = null))"
        >
          Add
        </el-button>
        <el-button
          type="danger"
          class="ml10 mb10"
          size="medium"
          @click="channel = ''"
        >
          Cancel
        </el-button>
      </span>
    </div>
  </el-dialog>
</template>

<script>
import axios from '@/plugins/axios'
import { mapState, mapActions, mapMutations } from 'vuex'

export default {
  data() {
    return {
      channel_id: '',
      channel: null
    }
  },

  computed: {
    ...mapState('preapproved', ['loading', 'dialog', 'channel_suggestions'])
  },

  methods: {
    ...mapActions('preapproved', ['insert']),
    ...mapMutations('preapproved', ['setDialog']),

    showSuggestions(channel_id, callback) {
      if (channel_id !== '') {
        axios.api
          .get('youtube/channels?channel_id=' + channel_id)
          .then(r => {
            let channels = r.data.data.suggestions
            if (r.data.data.channel.id) {
              channels = r.data.data.channel
              this.channel = channels
            }
            callback(channels)
          })
          .catch(error => {
            console.log(error)
            this.$message({
              message: 'Search error, please try again',
              type: 'error'
            })
          })
      }
    },

    handleSelect(data) {
      this.channel = data
    }
  }
}
</script>

<style lang="scss" scoped>
.channel {
  padding: 10px 5px;
  cursor: pointer;
  margin: 0;
  font-size: 15px;
  border-radius: 6px;
  &:hover {
    background: rgb(235, 235, 235);
  }
}
.input {
  width: 100%;
}
</style>
